import { ActionType, createReducer } from 'typesafe-actions'
import { resetCampaignDataAction } from '@/redux/company/handles/resetCampaignDataAction'
import { DepartmentAction, DepartmentState } from './types'
import { selectDeparmentHandle, clearSelectDeparmentHandle, fetchActiveDepartmentsHandle } from './handles'

type Action = DepartmentAction | ActionType<typeof resetCampaignDataAction>

const initialState: DepartmentState = {
  selectedDepartment: null,
  departmentCheck: null,
  isLoadingSelectDepartment: false,
  isErrorSelectDepartment: false,
  isSuccessSelectDepartment: false,
  activeDepartments: [],
  isLoadingFetchActiveDepartments: false,
  isErrorFetchActiveDepartments: false,
  isSuccessFetchActiveDepartments: false
}

export const departmentReducer = createReducer<DepartmentState, Action>(initialState)
  .handleAction(selectDeparmentHandle.asyncAction.request, selectDeparmentHandle.request)
  .handleAction(selectDeparmentHandle.asyncAction.success, selectDeparmentHandle.success)
  .handleAction(selectDeparmentHandle.asyncAction.failure, selectDeparmentHandle.failure)
  .handleAction(clearSelectDeparmentHandle.asyncAction, clearSelectDeparmentHandle.success)
  .handleAction(fetchActiveDepartmentsHandle.asyncAction.request, fetchActiveDepartmentsHandle.request)
  .handleAction(fetchActiveDepartmentsHandle.asyncAction.success, fetchActiveDepartmentsHandle.success)
  .handleAction(fetchActiveDepartmentsHandle.asyncAction.failure, fetchActiveDepartmentsHandle.failure)
  .handleAction(resetCampaignDataAction, state => ({
    ...state,
    selectedDepartment: null,
    departmentCheck: null,
    activeDepartments: []
  }))
